const compareContentIds = (left: string, right: string): number => {
    const leftMatch = left.match(/^[^_]+_(\d+)/);
    const rightMatch = right.match(/^[^_]+_(\d+)/);

    if (leftMatch && rightMatch) {
        const numberDifference = Number(leftMatch[1]) - Number(rightMatch[1]);
        if (numberDifference !== 0) {
            return numberDifference;
        }
    }

    return left < right ? -1 : left > right ? 1 : 0;
};

export const getOrderedContentIds = <T extends string>(ids: T[]): T[] =>
    [...ids].sort(compareContentIds);
